// extracted by mini-css-extract-plugin
var _1 = "OtiZEffU4AJnlDmATHxc";
export { _1 as "emptyTreePlaceholder" }
export default { "emptyTreePlaceholder": _1 }
